var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"app-header"},[_vm._m(0),_c('div',{staticClass:"app-title"},[_c('h2',[_vm._v(_vm._s(this.pageName))])])]),_c('hr')])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-logo"},[_c('img',{attrs:{"src":require("@/assets/logo.png")}})])
}]

export { render, staticRenderFns }